import { Routes } from "@angular/router";
import { ErrorHandler } from "@angular/core";
import * as Raven from "raven-js";
import { environment } from "../environments/environment";
var sentryDsn = (environment.sentryDsn) ? environment.sentryDsn : null;
if (sentryDsn) {
    Raven
        .config(sentryDsn)
        .install();
}
var RavenErrorHandler = /** @class */ (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        Raven.captureException(err);
    };
    return RavenErrorHandler;
}());
export { RavenErrorHandler };
var ɵ0 = { showMock: false }, ɵ1 = { showMock: true };
var routes = [
    {
        path: "signup",
        data: ɵ0,
        loadChildren: "app/signup/signup.module#SignupModule"
    },
    {
        path: "setup",
        data: ɵ1,
        loadChildren: "app/wizard/wizard.module#WizardModule"
    },
    {
        path: "**",
        pathMatch: "full",
        redirectTo: "signup",
    }
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
